module.exports = __webpack_public_path__ + "img/pacmanmodel (4).84708833.jpg";